import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { getSessionStatus } from '../../services/authService';
import { AUTH_SESSION_ENDED_EVENT, AuthSessionEndedDetail } from '../../services/authSession';
import { TOKEN_KEY, USER_ROLE_KEY } from '../../utils/constants';

const SESSION_CHECK_INTERVAL_MS = 30000;

const SessionWatcher: React.FC = () => {
  useEffect(() => {
    const checkSession = async () => {
      const token = localStorage.getItem(TOKEN_KEY);
      const role = localStorage.getItem(USER_ROLE_KEY);
      if (!token || role !== 'student') {
        return;
      }

      try {
        await getSessionStatus();
      } catch (error) {
        // Global axios handling redirects and clears auth for invalid sessions.
      }
    };

    void checkSession();

    const intervalId = window.setInterval(() => {
      void checkSession();
    }, SESSION_CHECK_INTERVAL_MS);

    const handleFocus = () => {
      void checkSession();
    };

    window.addEventListener('focus', handleFocus);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener('focus', handleFocus);
    };
  }, []);

  useEffect(() => {
    const handleSessionEnded = (event: Event) => {
      const detail = (event as CustomEvent<AuthSessionEndedDetail>).detail;
      if (!detail?.message) {
        return;
      }

      toast.info(detail.message);
    };

    window.addEventListener(AUTH_SESSION_ENDED_EVENT, handleSessionEnded);
    return () => {
      window.removeEventListener(AUTH_SESSION_ENDED_EVENT, handleSessionEnded);
    };
  }, []);

  return null;
};

export default SessionWatcher;
